import React, { ReactNode } from "react";
import CircleInfoError from "../../../public/images/circle-info-error.svg";
import styles from "./stylesToolTip.module.scss";

type PropsDef = {
  text: string | string[];
  orientation?: 'left' | 'right' | 'center';
  // Vertical direction the bubble opens. Defaults to 'top' (original behavior).
  // Use 'bottom' when the icon sits near the top of a clipping container, where
  // an upward bubble would be cut off.
  placement?: 'top' | 'bottom';
  selected?: boolean;
  isError?: boolean;
  children?: ReactNode;
  showIcon?: boolean;
  iconColor?: string | null;
  fontSize?: string;
  title?: string;
  subTitle?: string;
  // Cap the bubble width. The multiline bubble is 290px wide by default, which
  // overflows narrow scrolling columns; a cap lets it wrap instead of clip.
  maxWidth?: number | string;
};

export default function ToolTip({
  text,
  orientation = "left",
  placement = "top",
  isError = false,
  children = null,
  showIcon = true,
  iconColor = null,
  fontSize = "18px",
  title,
  subTitle,
  maxWidth,
}: PropsDef) {
  let orientationStyle;

  if (orientation === "left") {
    orientationStyle = styles.tooltiptext_left;
  } else if (orientation === "right") {
    orientationStyle = styles.tooltiptext_right;
  } else if (orientation === "center") {
    orientationStyle = styles.tooltiptext_center;
  }

  const placementStyle = placement === "bottom" ? styles.tooltiptext_below : "";

  const textLists = Array.isArray(text) ? text : [text];
  return (
    <div className={styles.tooltip}>
      {showIcon ? (
        isError ? (
          <img className={styles.icon} src={CircleInfoError} alt="info" />
        ) : (
          <i className={`ico ico-info ${iconColor === 'white' ? styles.iconWhite : ''} ${iconColor === 'gray' ? styles.iconGray : ''}`} style={{ fontSize }} />
        )
      ) : null}
      {children}
      <div
        style={maxWidth ? { width: maxWidth, maxWidth, minWidth: 0 } : undefined}
        className={`${styles.tooltiptext} ${orientationStyle} ${placementStyle} ${
          (typeof text === "string" && text.length > 40) || Array.isArray(text)
            ? styles.multiline
            : ""
        }`}
      >
        {title && <div className={styles.tooltipTitle}>{title}</div>}
        {textLists.map((value) => {
          return <div key={value}>{value}</div>;
        })}
        {subTitle && <div className={styles.tooltipSubTitle}>{subTitle}</div>}
      </div>
    </div>
  );
}
